// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"567032e7","114":"eee23cd9","137":"41fdfdec","294":"b0540ea9","421":"cc3430d8","465":"5d7f5a3f","488":"d2752e91","527":"2693ab86","581":"ff2cf464","700":"3cea6121","748":"ab54885e","854":"f632680c","898":"e799c3ea","982":"27bb4fec"}[chunkId] + ".chunk.js";
};